import { Box, Button, colors } from "@mui/material";
import React from "react";
import ACTLogoDark from "../../assets/images/ACT-logo-no-text-dark.png";
import SearchIcon from "@mui/icons-material/Search";
import LightModeIcon from "@mui/icons-material/LightMode";
import ReusableButton from "../button/ReusableButton";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { SEARCH_FILES } from "../search/searchIndex";
import MarkdownSearchBar from "../search/Markdownsearchbar";
import { logOutToPortal } from "../../utils/AuthUtils";
import { getPortalUrl } from "../../constants/Constants";
import { getAuthEnv, showsDemoLinks } from "../../constants/authEnvs";
import { useUser } from "../../context/UserContext";

const handleLogout = () => {
  logOutToPortal();
};

// const openDemo = () => {
//   window.open(
//     "https://demo.advancedcompliance.tech/login",
//     "_blank",
//     "noopener,noreferrer"
//   );
// };

const openDemo = () => {
  window.open(
    "https://demo.advancedcompliance.tech/",
    "_blank",
    "noopener,noreferrer"
  );
};

// Back to the portal the user signed in at (SID-2662).
const onLogoClick = () => {
  window.location.href = getPortalUrl();
};

const NavigationTopBar = () => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const { hasJurisdictions, canReturnToPortal } = useUser();
  const demoLinks = showsDemoLinks(getAuthEnv());

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.75rem 0 1.5rem 0",
        borderBottom: "0.1rem solid #d8d8d8",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {/* The logo returns the user to the portal's console picker. A user with a
            single application has nothing to pick, and the portal would log them
            out on the way back — so render it inert for them. */}
        <Button
          disableRipple
          disabled={!canReturnToPortal}
          onClick={onLogoClick}
          sx={{
            all: "unset",
            cursor: canReturnToPortal ? "pointer" : "default",
          }}
        >
          <img
            style={{
              height: "1.75rem",
              border: "none",
              display: "block",
            }}
            src={ACTLogoDark}
            alt="ACT Logo"
          />
        </Button>

        {/* <Box
          sx={{
            border: "0.01rem solid #d8d8d8",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "8rem",
            height: "2rem",
            borderRadius: "0.3rem",
            padding: "0 0.5rem",
          }}
        >
          translation
        </Box> */}
        {/* <Box
          sx={{
            borderBottom: "0.01rem solid #d8d8d8",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "8rem",
            height: "2rem",
          }}
        >
          <SearchIcon />
          search
        </Box> */}
        {/* <MarkdownSearchBar
          files={SEARCH_FILES}
          onSelect={(r) => navigate(r.path)}
        /> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2vw",
            backgroundColor: "#d8d8d8",
            padding: "0 2rem",
            height: "2rem",
            borderRadius: "1rem",
          }}
        >
          {/* <Link
            to="#"
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              color: hover ? "#555555" : "#000000",
              fontSize: "0.8rem",
              fontWeight: 500,
              letterSpacing: "0.5px",
              textDecoration: "underline",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            ACT Geosafe Console
          </Link> */}

          {demoLinks && (
            <Link
              to="https://demo-verify.advancedcompliance.tech/"
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                color: hover ? "#555555" : "#000000",
                fontSize: "0.8rem",
                fontWeight: 500,
                letterSpacing: "0.5px",
                textDecoration: "underline",
                cursor: "pointer",
                textAlign: "center",
              }}
            >
              ACT Verify QR Generator
            </Link>
          )}

          <Link
            to="/contact/help-center"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              color: hover ? "#555555" : "#000000",
              fontSize: "0.8rem",
              fontWeight: 500,
              letterSpacing: "0.5px",
              textDecoration: "underline",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            Support
          </Link>
        </Box>

        {hasJurisdictions && demoLinks && (
          <ReusableButton
            onClick={openDemo}
            content={"Demo"}
            bgColor="#e54f9c"
            textColor="#ffffff"
            hoverColor="#fcd4e9"
            hoverTextColor="#000000"
            border="0.1rem solid  #e54f9c"
            borderRadius="0.2rem"
            hoverBorder="0.1rem solid #fcd4e9"
            width="6rem"
          />
        )}

        <ReusableButton
          onClick={handleLogout}
          content={"Logout"}
          bgColor="#ffffff"
          textColor="#e54f9c"
          hoverColor="#fcd4e9"
          hoverTextColor="#000000"
          border="0.1rem solid #e54f9c"
          borderRadius="0.2rem"
          hoverBorder="0.1rem solid #fcd4e9"
          width="6rem"
        />

        {/* <Box
          sx={{
            height: "2rem",
            width: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <LightModeIcon />
        </Box> */}
      </Box>
    </Box>
  );
};

export default NavigationTopBar;
